import { CircularProgress, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles({
  container: {
    margin: "80px 0",
    textAlign: "center" as "center"
  }
});

const Loader = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CircularProgress />
    </div>
  );
};

export default React.memo(Loader);
